import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorComponent } from '../confirm/error.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';

@Component({ templateUrl: './managementusers.component.html', styleUrls: ['./managementusers.component.css'] })
export class ManagementUsersComponent implements OnInit {

    @ViewChild('closeModel', { read: ElementRef }) closeModel: ElementRef;
    users: any = {};
    managementUserForm: any;
    config: any;
    managementUserInfoList: any[] = [];
    towerInfoList: any[] = [];
    submitted = false;
    loginImageURL: any = "";
    loginUserName: any = "";
    baseURL: any = null;
    showHideModel: boolean = true;
    loading: boolean = false;
    activeUserCount: number = 0;
    inactiveUserCount: number = 0;
    towerId: any;
    towerName: any;
    superUserType: any = "";
    imageURL = "https://i0.wp.com/www.winhelponline.com/blog/wp-content/uploads/2017/12/user.png?fit=256%2C256&quality=100&ssl=1";

    userRoles: any[] = [];
    isSuperAdmin: any = false;
    isHrUser: any = false;
    ibuList: any = [];
    checkedIbuList: any = [];
    selectedUserIbu: any = [];
    updatedIbuList: any = [];
    constructor(private modalService: MatDialog,
        private router: Router,
        private formBuilder: FormBuilder,
        private commonService: CommonService,
        private appConfig: AppConfig,
        config: NgbDatepickerConfig,
        private common: Common,
        private _compiler: Compiler) {
        this._compiler.clearCache();
        this.users = JSON.parse(localStorage.getItem('user'));
        if (!this.users || !this.users.userData) {
            this.commonService.logout
            return;
        }
        if (this.users && this.users.userData) {
            this.loginImageURL = this.users.userData.imageURL;
            this.loginUserName = this.users.userData.userFullName;
            this.towerId = this.users.userData.towerId;
            this.towerName = localStorage.getItem('towerName');
            // this.allowToSeeProjectAndAccountBULevel = this.users.userData.allowToSeeProjectAndAccountBULevel;
        }
        if (localStorage.getItem('superUserType')) {
            this.superUserType = localStorage.getItem('superUserType');
        }
        if (this.common.isSuperUser()) {
            this.isSuperAdmin = true;
        }
        let currentDate = new Date();
        this.config = config;
        this.config.minDate = { year: currentDate.getFullYear() - 10, month: currentDate.getMonth(), day: currentDate.getDate() };
        this.config.maxDate = { year: 2099, month: 12, day: 31 };
        this.config.markDisabled = false;
        this.initUserInfo();
    }

    //initailised user form
    ngOnInit() {
        this.getIbuList();
        this.initUserInfo();
        this.initialization();
    }

    //initial setup level assets
    private initialization() {
        this.getAllManagementUsersInfo();
        this.getAllTowsersInfo();
        this.getAllUserRoleList();
    }

    //reset user form
    initUserInfo() {
        if (this.superUserType == "super") {
            this.managementUserForm = this.formBuilder.group({
                userFullName: ['', Validators.required],
                userName: ['', Validators.required],
                userEmail: ['', Validators.required],
                userRoll: new FormControl("Select Role"),
                userStatus: new FormControl("User Status"),
            });
        } else {
            this.managementUserForm = this.formBuilder.group({
                userFullName: ['', Validators.required],
                userName: ['', Validators.required],
                userEmail: ['', Validators.required],
                userRoll: new FormControl("Select Role"),
                ibuId: new FormControl([]),
                userStatus: new FormControl("User Status"),
            });
        }

    }

    //reset user form 
    private setUpdateUserInfo(managementUser) {
        this.initUserInfo();
        this.selectedUserIbu = (managementUser.ibuId) ? managementUser.ibuId.split(',') : [];
        this.checkedIbuList = this.selectedUserIbu;
        for (let i = 0; i < this.updatedIbuList.length; i++) {
            const index = this.selectedUserIbu.findIndex(x => Number(x) == this.updatedIbuList[i].ibuId);
            if (index != -1) {
                this.updatedIbuList[i].isChecked = true;
            } else {
                this.updatedIbuList[i].isChecked = false;
            }
        }
        if (managementUser.userRoll == 3 || managementUser.userRoll == 7) {
            this.isHrUser = true;
        } else {
            this.isHrUser = false;
        }
        this.managementUserForm = this.formBuilder.group({
            userFullName: new FormControl(managementUser.userFullName),
            userName: new FormControl(managementUser.userName),
            userEmail: new FormControl(managementUser.userEmail),
            userRoll: new FormControl(managementUser.userRoll),
            ibuId: new FormControl(managementUser.ibuId),
            userId: new FormControl(managementUser.userId),
            userStatus: new FormControl(managementUser.userStatus),
        });

    }



    //Get all accounts info
    private getAllManagementUsersInfo() {
        this.loading = true;
        this.managementUserInfoList = [];
        this.commonService.getManagementUsersList().pipe(first()).subscribe(
            data => {
                this.managementUserInfoList = data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.showerror();
            }
        )
    }

    //Get all accounts info
    private getManagementUsersListByTowerId() {
        this.loading = true;
        this.managementUserInfoList = [];
        this.commonService.getManagementUsersListByTowerId(this.towerId).pipe(first()).subscribe(
            data => {
                this.managementUserInfoList = data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.showerror();
            }
        )
    }
    //Get all towsers info
    private getAllTowsersInfo() {
        this.loading = true;
        this.towerInfoList = [];
        this.commonService.getTowerList().pipe(first()).subscribe(
            data => {
                this.towerInfoList = data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.showerror();
            }
        )
    }

    //Get tower info by towerId
    //Get all accounts info
    private getTowerInfo(isFatchAll) {
        this.loading = true;
        this.towerInfoList = [];
        this.commonService.getTowerInfo(this.towerId, isFatchAll).pipe(first()).subscribe(
            data => {
                this.towerInfoList = data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.showerror();
            }
        )
    }

    // Save new user profile
    private onSubmit(managementUserInfo) {
        if (this.managementUserForm.invalid) {
            this.submitted = true;
            return;
        } else {

            managementUserInfo['ibuId'] = this.checkedIbuList.join();
            if (this.isHrUser && this.checkedIbuList.length < 1) {
                localStorage.setItem('errorMsg', 'Please select IBU');
                this.showerror();
                return;
            }
            if (managementUserInfo.userRoll == "Select Role") {
                localStorage.setItem('errorMsg', 'Must Select Role!');
                this.showerror();
                return;
            }

            if (this.checkUserAlreadyExits(managementUserInfo.userName, managementUserInfo.userEmail)) {
                localStorage.setItem('errorMsg', 'This user already exits!');
                this.showerror();
                return
            }


            if (!this.validateEmail(managementUserInfo.userEmail)) {
                localStorage.setItem('errorMsg', 'Invaild Email!');
                this.showerror();
                return
            }

            this.loading = true;
            //set login user email
            this.commonService.saveManagementUserInfo(managementUserInfo).pipe(first()).subscribe(
                data => {
                    this.loading = false;
                    this.managementUserForm.reset();
                    localStorage.setItem('errorMsg', 'Profile Added successfully!');
                    this.initialization();
                    this.showerror();
                },
                error => {
                    this.loading = false;
                    localStorage.setItem('errorMsg', 'Must enter all the fields!');
                    this.showerror();
                }
            )
        }
    }

    private validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    // update user profile 
    private updateManagementUserInfo(managementUserInfo) {
        if (this.managementUserForm.invalid) {
            localStorage.setItem('errorMsg', 'Please enter user information!');
            this.showerror();
            return
        }
        if (managementUserInfo != null) {
            managementUserInfo['ibuId'] = this.checkedIbuList.join();
            if (this.isHrUser && this.checkedIbuList.length < 1) {
                localStorage.setItem('errorMsg', 'Please select IBU');
                this.showerror();
                return;
            }

            if (managementUserInfo) {
                if (managementUserInfo.userRoll == "Select Role") {
                    localStorage.setItem('errorMsg', 'Must Select Role!');
                    this.showerror();
                    return;
                }

                if (!this.validateEmail(managementUserInfo.userEmail)) {
                    localStorage.setItem('errorMsg', 'Invaild Email!');
                    this.showerror();
                    return
                }
                this.loading = true;
                //set login user email
                this.commonService.updateManagementUserInfo(managementUserInfo).pipe(first()).subscribe(
                    data => {

                        localStorage.setItem('user', JSON.stringify(this.users));
                        this.loading = false;
                        this.initialization();
                        this.closeModels();
                        localStorage.setItem('errorMsg', 'Management user updated successfully!');
                        this.showerror();
                    },
                    error => {
                        this.loading = false;
                        localStorage.setItem('errorMsg', error.statusText);
                        this.showerror();
                    }
                )
            }
        }
    }

    // Delete user profile
    private onDeleteSubmit(userInfo) {
        this.loading = true;
        //set login user email
        this.commonService.userDeletion(userInfo).pipe(first()).subscribe(
            data => {
                this.loading = true;
                localStorage.setItem('errorMsg', 'IBU is deleted successfully!');
                localStorage.removeItem('errorMsg');
                this.initialization();
                this.showerror();
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.showerror();
            }
        )
    }

    //check management user already exits
    private checkUserAlreadyExits(userName, userEmail) {
        let isUserExits = false;
        userName = userName.toLowerCase();
        for (let i = 0; i < this.managementUserInfoList.length; i++) {
            let ursName = this.managementUserInfoList[i].userName.toLowerCase();
            if (ursName == userName || this.managementUserInfoList[i].userEmail == userEmail) {
                isUserExits = true;
            }
        }
        return isUserExits;
    }

    // Get all user role list
    private getAllUserRoleList() {
        this.loading = true;
        this.userRoles = [];
        this.commonService.getAllUserRoleList().pipe(first()).subscribe(
            data => {
                for (let i = 0; i < data.length; i++) {
                    if (!this.common.isSuperUser() && (data[i].roleId === 3 || data[i].roleId === 4 || data[i].roleId === 6)) {
                        this.userRoles.push(data[i]);
                    }
                    if (this.common.isSuperUser() && (data[i].roleId === 1 || data[i].roleId === 3 || data[i].roleId === 4 || data[i].roleId === 6 || data[i].roleId === 7)) {
                        this.userRoles.push(data[i]);
                    }
                }
                // this.userRoles = data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.showerror();
            }
        )
    }

    // Get ibu name based on ibuId
    private getUserRoleName(roleId) {
        let userRoleName = "";
        for (let i = 0; i < this.userRoles.length; i++) {
            if (this.userRoles[i].userRoleId == roleId) {
                userRoleName = this.userRoles[i].userRoleName;
                break;
            }
        }
        return userRoleName;
    }

    //close dailog box
    private closeModels() {
        this.closeModel.nativeElement.click();
    }

    //show dailog box for user messages
    showerror() {

        const modal = this.modalService.open(ErrorComponent, {
            width: 'auto',
            data: { title: 'Confirm title', message: 'Confirm message' }
        });
    }


    /**
       * Get list of IBU
       */
    getIbuList() {
        this.commonService.getAllIBUInfo().subscribe(data => {
            this.ibuList = data;
            for (let i = 0; i < this.ibuList.length; i++) {
                const obj = {
                    ibuId: this.ibuList[i].ibuId,
                    ibuName: this.ibuList[i].ibuName,
                    isChecked: false,
                }
                this.updatedIbuList.push(obj);
            }
        },
            error => {
            });
    }
    /**
     * Change Role
     */
    changeRole(event) {
      //  this.checkedIbuList = [];
        this.isHrUser = false;
        if (event.target.value == 3 || event.target.value == 7) {
            this.isHrUser = true;
        }
    }
    /**
     * Change checkBox value
     */
    onCheckboxChange(event) {
        const index = this.checkedIbuList.findIndex(x => x == Number(event.target.value));
        if (index == -1) {
            this.checkedIbuList.push(Number(event.target.value));
        } else {
            this.checkedIbuList.splice(index, 1);
        }
    }

}
